import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-32 pb-20 px-6 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row gap-16 items-center">
        
        {/* Image */}
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full md:w-1/2"
        >
          <div className="relative aspect-[3/4] w-full max-w-md mx-auto overflow-hidden shadow-2xl">
            <img 
              src="https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=1000&auto=format&fit=crop" 
              alt="Gisselle Mendez in her studio" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 border-4 border-gallery-bg/20 m-4"></div>
          </div>
        </motion.div>

        {/* Text */}
        <motion.div 
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="w-full md:w-1/2 space-y-8"
        >
          <h1 className="text-5xl font-serif mb-8">{t('about.title')}</h1>
          <div className="w-16 h-px bg-gallery-accent"></div>
          
          <div className="space-y-6 text-lg text-gallery-muted leading-relaxed font-light">
            <p>{t('about.bio1')}</p>
            <p>{t('about.bio2')}</p>
            <p>
              "El lienzo es un espacio de silencio donde los colores hablan el lenguaje de la memoria. Busco texturas que el ojo pueda sentir."
            </p>
          </div>
          
          <div className="pt-8">
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/d/d4/Signature_of_John_Hancock.svg" 
              alt="Signature" 
              className="h-12 opacity-40"
              style={{ filter: 'invert(1)' }} // Assuming dark text on light bg, adjust if needed
            />
          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default About;